import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-popup__schedule-content"
}
const _hoisted_2 = { class: "as-popup__schedule-header" }
const _hoisted_3 = { class: "as-popup__schedule-body" }
const _hoisted_4 = { class: "as-popup__schedule-team-info" }
const _hoisted_5 = { class: "as-time as-flex as-text-center" }
const _hoisted_6 = { class: "as-info as-flex as-text-center" }
const _hoisted_7 = { class: "as-team-home" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "as-team-name" }
const _hoisted_10 = { class: "as-score" }
const _hoisted_11 = { class: "as-popup__schedule-score" }
const _hoisted_12 = { class: "as-team-away" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "as-team-name" }
const _hoisted_15 = { class: "as-popup__schedule-link" }
const _hoisted_16 = {
  key: 0,
  class: "as-stream-links-grid"
}
const _hoisted_17 = { class: "as-stream-link-item" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "as-stream-link-item__name" }

import { computed } from "vue";
import type { IMatch, ISites } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamNameShow } from "~src/helpers";
import { usecommonStore } from "~src/stores/CommonStore";
import AsPopup from "~src/components/AsPopup.vue";

interface IProps {
  isShowPopup: Boolean;
  match: IMatch;
  sites: ISites[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupLinkStream',
  props: {
    isShowPopup: {},
    match: {},
    sites: {}
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const commonStore = usecommonStore();

const emits = __emit;

const props = __props;
const siteName = computed(() => commonStore.getSiteName);

const toggle = () => {
  emits("toggle");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AsPopup, {
    title: "Video trực tiếp",
    wrapClass: "as-popup__schedule-wrap",
    popupClass: `as-popup__schedule as-popup__schedule-${siteName.value}`,
    isShowPopup: _ctx.isShowPopup,
    isShowHeader: false,
    onToggle: toggle
  }, {
    content: _withCtx(() => [
      (_ctx.match)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-popup__schedule-title" }, " Video trực tiếp ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "as-popup__schedule-close-btn",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle', false)))
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatLocalTime)(_ctx.match.match_time, "h:mm DD/MM")), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('team', _ctx.match.home_team?.id),
                      alt: _unref(getTeamNameShow)(_ctx.match.home_team),
                      class: "as-lazyload as-popup__schedule-team-logo"
                    }, null, 8, _hoisted_8),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getTeamNameShow)(_ctx.match.home_team)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`as-score-vs as-score-vs__only-text as-score-vs__only-text-${siteName.value}`)
                      }, " VS ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('team', _ctx.match.away_team?.id),
                      alt: _unref(getTeamNameShow)(_ctx.match.away_team),
                      class: "as-lazyload as-popup__schedule-team-logo"
                    }, null, 8, _hoisted_13),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getTeamNameShow)(_ctx.match.away_team)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.sites)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_17, [
                          _createElementVNode("a", {
                            href: `https://${site.domain}/${site.slug}/${_ctx.match.match_live_item?.name}`,
                            target: "_blank"
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`as-stream-link-item__logo as-stream-link-item__logo-${site.name}`)
                            }, null, 2),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(site?.title ?? site.name), 1)
                          ], 8, _hoisted_18)
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-popup__schedule-note" }, [
                _createElementVNode("span", { class: "as-stream-note-text" }, " Các video trực tiếp được cư dân mạng chia sẻ. ")
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["popupClass", "isShowPopup"]))
}
}

})